import React from 'react'
import cx from 'classnames'
import { Icon, Link, l } from '@manychat/manyui'

import cm from './BusinessAgentBanner.module.css'

const ICON_SIZE = 20

interface BusinessAgentBannerProps {
  onLearnMoreClick: () => void
}

export const BusinessAgentBanner = ({ onLearnMoreClick }: BusinessAgentBannerProps) => {
  return (
    <div className={cm.banner} role="status" data-test-id="cms-business-agent-banner">
      <Icon.MetaBusinessAgent size={ICON_SIZE} className={cm.icon} />

      <p className={cx('text-body', cm.text)}>
        {l.translate(
          'WhatsApp automations do not send messages while Meta Business Agent is active',
        )}
      </p>

      <Link as="button" type="button" onClick={onLearnMoreClick}>
        {l.translate('Learn more')}
      </Link>
    </div>
  )
}
